import { createScreenText } from 'helpers/screenText';
const st = createScreenText('helper_phone_validation');

// src/helpers/phoneValidation.ts
// Validate so dien thoai di dong Viet Nam theo dung dau so cua tung nha mang (quy hoach kho so
// 10 so cua Bo TT&TT sau dot chuyen doi nam 2018). Dung chung cho form tao/sua Dai ly va Nguoi
// dung thay vi moi noi tu viet regex rieng (truoc day chi check "10 so, bat dau bang 0").
const VIETTEL_PREFIXES = [
  "032", "033", "034", "035", "036", "037", "038", "039", "086", "096", "097", "098",
];
const VINAPHONE_PREFIXES = ["081", "082", "083", "084", "085", "088", "091", "094"];
const MOBIFONE_PREFIXES = ["070", "076", "077", "078", "079", "089", "090", "093"];
const VIETNAMOBILE_PREFIXES = ["052", "056", "058", "092"];
const ITEL_PREFIXES = ["087"];
const WINTEL_PREFIXES = ["059", "099"];

const ALL_MOBILE_PREFIXES = [
  ...VIETTEL_PREFIXES,
  ...VINAPHONE_PREFIXES,
  ...MOBIFONE_PREFIXES,
  ...VIETNAMOBILE_PREFIXES,
  ...ITEL_PREFIXES,
  ...WINTEL_PREFIXES,
];

// VD hop le: 0987654321 (Viettel), 0912345678 (VinaPhone)...
export const VN_MOBILE_PHONE_REGEX = new RegExp(
  `^(${ALL_MOBILE_PREFIXES.join("|")})\\d{7}$`,
);

export const VN_MOBILE_PHONE_ERROR_MESSAGE =
  st('so_dien_thoai_khong_dung_dinh_text');
